// Live "order within X days Y hrs Z mins" countdown in the header, driven by
// the shopper's zip code (resolved to a Local/Shipping zone server-side,
// which determines the applicable DeliveryOption). The zip-check form
// appears on the home page and the cart page: on the home page it patches
// the header's countdown in place (no reload); on the cart page the
// Expected Delivery Date <select> is server-rendered from the resolved
// zone, so that instance reloads the page instead (data-reload-on-success).

var countdownInterval = null

function renderCountdown(cutoffAt, element) {
  clearInterval(countdownInterval)
  if (!cutoffAt) {
    element.textContent = ''
    return
  }

  var target = new Date(cutoffAt).getTime()

  function tick() {
    var remaining = Math.floor((target - Date.now()) / 1000)
    if (remaining <= 0) {
      element.textContent = '0 days 0 hrs 0 mins'
      clearInterval(countdownInterval)
      return
    }

    var days = Math.floor(remaining / 86400)
    var hours = Math.floor((remaining % 86400) / 3600)
    var minutes = Math.floor((remaining % 3600) / 60)
    element.textContent = (days > 0 ? days + ' days ' : '') + hours + ' hrs ' + minutes + ' mins'
  }

  tick()
  countdownInterval = setInterval(tick, 30000)
}

document.addEventListener('turbolinks:load', function () {
  var countdownEl = document.getElementById('header-countdown')
  if (countdownEl) renderCountdown(countdownEl.dataset.cutoffAt, countdownEl)

  try {
    var pending = sessionStorage.getItem('pj_zip_check_message')
    if (pending) {
      sessionStorage.removeItem('pj_zip_check_message')
      var data = JSON.parse(pending)
      var messageEl = document.querySelector('.js-zip-check-form[data-reload-on-success="true"] + .zip-check-message')
      if (messageEl) {
        messageEl.textContent = data.text
        messageEl.hidden = false
        messageEl.classList.toggle('zip-check-message-invalid', data.invalid)
      }
    }
  } catch (e) { /* private mode / storage disabled */ }
})

function csrfToken() {
  var meta = document.querySelector('meta[name="csrf-token"]')
  return meta ? meta.content : ''
}

document.addEventListener('submit', function (event) {
  var form = event.target.closest('.js-zip-check-form')
  if (!form) return

  event.preventDefault()

  var zip = form.querySelector('.zip-check-input').value.trim()
  var messageEl = form.parentElement.querySelector('.zip-check-message')

  fetch('/delivery-zip', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-CSRF-Token': csrfToken(),
      Accept: 'application/json'
    },
    body: 'zip=' + encodeURIComponent(zip)
  })
    .then(function (response) { return response.json() })
    .then(function (data) {
      if (form.dataset.reloadOnSuccess === 'true') {
        // The date list on this page is server-rendered from the resolved
        // zone, so reload rather than trying to patch a <select>'s options.
        try {
          sessionStorage.setItem('pj_zip_check_message', JSON.stringify({ text: data.message, invalid: !data.valid }))
        } catch (e) { /* private mode / storage disabled - message just won't persist across reload */ }
        Turbolinks.visit(window.location.href, { action: 'replace' })
        return
      }

      var labelEl = document.getElementById('header-delivery-label')
      var countdownEl = document.getElementById('header-countdown')

      if (labelEl && countdownEl) {
        if (data.date_label) {
          labelEl.innerHTML = 'Fastest delivery <b>' + data.date_label + '</b>, order within'
          countdownEl.dataset.cutoffAt = data.cutoff_at
          renderCountdown(data.cutoff_at, countdownEl)
        } else {
          labelEl.textContent = 'Delivery scheduling coming soon'
          countdownEl.textContent = ''
        }
      }

      if (messageEl) {
        messageEl.textContent = data.message
        messageEl.hidden = false
        messageEl.classList.toggle('zip-check-message-invalid', !data.valid)
      }
    })
    .catch(function () {
      if (messageEl) {
        messageEl.textContent = 'Something went wrong. Please try again.'
        messageEl.hidden = false
      }
    })
}, true)
